'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: ', ';\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  flex: 1;\n  overflow: scroll;\n  display: flex;\n'], ['\n  width: 100%;\n  flex: 1;\n  overflow: scroll;\n  display: flex;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 5px 10px;\n  background: ', ';\n  white-space: nowrap;\n  cursor: pointer;\n  border-style: none solid solid none;\n  border-width: 0px 1px 3px 0px;\n  border-color: ', ';\n'], ['\n  padding: 5px 10px;\n  background: ', ';\n  white-space: nowrap;\n  cursor: pointer;\n  border-style: none solid solid none;\n  border-width: 0px 1px 3px 0px;\n  border-color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: block;\n  color: ', ' !important;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0px 5px;\n'], ['\n  display: block;\n  color: ', ' !important;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0px 5px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.grey);

var Tabs = _styledComponents2.default.div(_templateObject2);

var Tab = _styledComponents2.default.div(_templateObject3, function (_ref) {
  var selected = _ref.selected;
  return selected ? _colors.white : 'none';
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? 'transparent transparent ' + _colors.red + ' transparent' : 'transparent ' + _colors.white + ' transparent transparent';
});

var CloseIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject4, _colors.darkGrey);

var Header = function Header(_ref3) {
  var files = _ref3.files,
      selected = _ref3.selected,
      onSelect = _ref3.onSelect,
      onClose = _ref3.onClose;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Tabs, null, files.map(function (file) {
    return _react2.default.createElement(Tab, {
      key: file.id,
      onClick: function onClick(e) {
        return onSelect(_extends({}, file));
      },
      selected: selected && selected.id === file.id
    }, file.name);
  })), _react2.default.createElement(CloseIcon, {
    icon: 'close',
    onClick: onClose
  }));
};

Header.propTypes = {
  files: _propTypes2.default.array,
  selected: _propTypes2.default.object,
  onSelect: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};
exports.default = Header;